
import { Outlet } from "react-router-dom";
import { Meta } from "@/components";

const Career = () => {
  return (
    <>
    <Meta
        title="Intron - Career"
    />
      <Outlet />
    </>
  );
};

export default Career;
